const TodoHeader = ({ children }) => {
    return (
        <header>
            {children}
        </header>
    )
}

export default TodoHeader;